// extracted by mini-css-extract-plugin
export default {"mensagem":"mensagem_mensagem__+T+3a","fadeIn":"mensagem_fadeIn__yyDFH"};